import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/contrato/avanceReal/contratoCatalogoConceptos.gql';
import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';
import AGREGAR_CONTRATO_AVANCE_REAL from '@/graphql/mutations/administracion/contratos/contrato/avanceReal/agregarContratoAvanceReal.gql';
import CONTRATO_CATALOGO_FAVORITOS from '@/graphql/querys/administracion/contratos/contrato/catalogofavoritos/contratoCatalogoFavoritos.gql';

export default {
  data() {
    return {
    };
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.idContrato,
        };
      },
    },
    contratoCatalogoConceptos: {
      query: CONTRATO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoCatalogoFavoritos: {
      query: CONTRATO_CATALOGO_FAVORITOS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  methods: {
    async mixAgregarContratoAvanceReal() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_AVANCE_REAL,
          variables: {
            avanceReal: this.avanceReal,
          },
          update: (store, { data: { agregarContratoAvanceReal } }) => {
            // set query
            const query = {
              query: CONTRATO_CATALOGO_CONCEPTOS,
              variables: {
                idContrato: this.idContrato,
              },
            };

            // get contrato catalogo de conceptos
            const data = store.readQuery(query);
            const { contratoCatalogoConceptos } = data;

            // Buscar el concepto
            const concepto = contratoCatalogoConceptos
              .find(({ id }) => id === agregarContratoAvanceReal.idConcepto);

            const avance = concepto.avancesReales
              .find(({ id }) => id === agregarContratoAvanceReal.id);

            if (avance) {
              // Buscar index
              const index = concepto.avancesReales
                .findIndex(({ id }) => id === agregarContratoAvanceReal.id);
              concepto.avancesReales.splice(index, 1, agregarContratoAvanceReal);
            } else {
              concepto.avancesReales.push(agregarContratoAvanceReal);
            }

            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getEstimaciones() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones.filter(({ fechaAl }) => {
        if (!this.fechaAvanceFisico) return true;
        return new Date(`${this.fechaAvanceFisico} 00:00:0`) >= new Date(`${fechaAl} 00:00:0`);
      });
    },
    getCatalogo() {
      if (!this.contratoCatalogoConceptos) return [];
      return this.contratoCatalogoConceptos
        .slice()
        .sort((a, b) => a.orden - b.orden)
        .map((concepto) => {
          let nivel = 1;
          const tengoPadreSubNivel = this.contratoCatalogoConceptos
            .filter((c) => c.tipo === 1)
            .some((c) => concepto.idPadre === c.id);

          // Si nivel 2
          if (concepto.tipo === 1) {
            nivel = 2;
          }

          // Si es nivel 3
          if (concepto.tipo === 1 && tengoPadreSubNivel) {
            nivel = 3;
          }

          // Si es nivel 4 o concepto
          if (concepto.tipo === 2) {
            nivel = 4;
          }

          return {
            ...concepto,
            nivel,
          };
        })
        .map((concepto) => {
          const { estimado } = concepto;
          if (estimado.length <= 0) {
            return {
              ...concepto,
              ultimaEstimacion: null,
              ultimoAvanceReal: null,
              disponible: concepto.cantidad,
            };
          }

          const numeroEstimaciones = estimado.map((est) => est.estimacion.numero);
          const numeroUltimaEstimacion = Math.max(...numeroEstimaciones);

          const ultimaEstimacion = estimado
            .find((est) => est.estimacion.numero === numeroUltimaEstimacion);

          return {
            ...concepto,
            ultimaEstimacion: {
              cantidad: ultimaEstimacion.cantidad,
              importe: ultimaEstimacion.importe,
              fechaDel: ultimaEstimacion.estimacion.fechaDel,
              fechaAl: ultimaEstimacion.estimacion.fechaAl,
              esEstimado: true,
            },
            ultimoAvanceReal: null,
            disponible: this.$numberRoundDigits(
              (concepto.cantidad - (ultimaEstimacion.cantidad || 0)), 5,
            ),
            avance: ultimaEstimacion.cantidad,
          };
        })
        .map((concepto) => {
          // Si no hay avance real registrado entonces, regresamos
          // el concepto como va
          if (concepto.avancesReales.length <= 0) {
            return {
              ...concepto,
            };
          }

          // set Cantidad de avance de la ultima estimacion
          const cantidadEstimada = concepto.ultimaEstimacion?.cantidad || 0;

          // Si existe avance real registrado, extraemos la informacion
          const avancesReales = concepto.avancesReales
            .filter(({ fecha }) => {
              if (!this.fechaAvanceFisico) return true;
              return fecha === this.fechaAvanceFisico;
            })
            .slice()
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          // obtener el primero registro
          const ultimoAvanceReal = avancesReales[0];

          return {
            ...concepto,
            ultimoAvanceReal,
            avance: (cantidadEstimada + (ultimoAvanceReal?.cantidad || 0)),
          };
        });
    },
    getConceptosFavoritos() {
      if (!this.contratoCatalogoFavoritos) return [];
      return this.contratoCatalogoFavoritos
        .slice()
        .sort((a, b) => a.orden - b.orden)
        .map((favorito) => ({
          ...favorito,
          tipo: 2,
        }))
        .map((favorito) => {
          const { estimado } = favorito.concepto;

          if (estimado.length <= 0) {
            return {
              ...favorito,
              ultimaEstimacion: null,
              ultimoAvanceReal: null,
              disponible: favorito.concepto.cantidad,
            };
          }

          const numeroEstimaciones = estimado.map((est) => est.estimacion.numero);
          const numeroUltimaEstimacion = Math.max(...numeroEstimaciones);

          const ultimaEstimacion = estimado
            .find((est) => est.estimacion.numero === numeroUltimaEstimacion);

          return {
            ...favorito,
            ultimaEstimacion: {
              cantidad: ultimaEstimacion.cantidad,
              importe: ultimaEstimacion.importe,
              fechaDel: ultimaEstimacion.estimacion.fechaDel,
              fechaAl: ultimaEstimacion.estimacion.fechaAl,
              esEstimado: true,
            },
            ultimoAvanceReal: null,
            disponible: this.$numberRoundDigits(
              (favorito.concepto.cantidad - (ultimaEstimacion.cantidad)), 5,
            ),
            avance: ultimaEstimacion.cantidad,
          };
        })
        .map((favorito) => {
          const { avancesReales } = favorito.concepto;

          if (avancesReales.length <= 0) {
            return {
              ...favorito,
            };
          }

          // set Cantidad de avance de la ultima estimacion
          const cantidadEstimada = favorito.ultimaEstimacion?.cantidad || 0;

          // Si existe avance real registrado, extraemos la informacion
          const avancesRealesFiltrados = avancesReales
            .filter(({ fecha }) => {
              if (!this.fechaAvanceFisico) return true;
              return new Date(`${fecha} 00:00:0`) <= new Date(`${this.fechaAvanceFisico} 00:00:0`);
            })
            .slice()
            .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));
          // obtener el primero registro
          const ultimoAvanceReal = avancesRealesFiltrados[0];

          return {
            ...favorito,
            ultimoAvanceReal,
            avance: (cantidadEstimada + (ultimoAvanceReal?.cantidad || 0)),
          };
        });
    },
    getConceptosConAvanceReal() {
      return this.getCatalogo.filter(({ ultimoAvanceReal }) => ultimoAvanceReal !== null);
    },
    importeContrato() {
      return (this.getContrato.importe + this.getContrato.modificado?.importe);
    },
    importeCatalogo() {
      const catalogo = this.getCatalogo.filter(({ tipo }) => tipo === 2);
      return this.$ObjSumar(catalogo, 'importe');
    },
    importeAvanceReal2() {
      const importeEstimado = this.$ObjSumar(this.getEstimaciones, 'importeEstimado');
      const catalogoConAvanceReal = this.getCatalogo
        .filter(({ ultimoAvanceReal }) => ultimoAvanceReal !== null)
        .map(({ ultimoAvanceReal }) => ({
          importe: ultimoAvanceReal?.importe,
        }));
      console.log(catalogoConAvanceReal);
      const importeAvanceReal = this.$ObjSumar(catalogoConAvanceReal, 'importe');

      return (importeEstimado + importeAvanceReal);
    },
    porcentajeAvanceReal2() {
      return this.$numberRoundDigits(((this.importeAvanceReal2 / this.importeContrato) * 100), 2);
    },
  },
};
